import React from "react";
import Hls from "hls.js";
import { Spin } from "antd";

class HLSPlayer extends React.Component {
  constructor(props) {
    super(props);
    this.videoRef = React.createRef();
    this.hls = null;
    this.state = {
      showVideo: false,
      loading: true
    };
    this.timeout = null;
  }

  componentDidMount() {
    // Start 15-second delay
    let interval = 15000;
    if (this.props.interval) {
      interval = this.props.interval;
    }
    this.timeout = setTimeout(() => {
      this.setState({ showVideo: true }, this.initializeHLS);
    }, interval);
  }

  componentWillUnmount() {
    if (this.hls) {
      this.hls.destroy();
    }
    clearTimeout(this.timeout);
  }

  initializeHLS = () => {
    const { src } = this.props;

    if (Hls.isSupported()) {
      this.hls = new Hls();
      this.hls.loadSource(src);
      this.hls.attachMedia(this.videoRef.current);

      this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
        this.setState({ loading: false });
      });

      this.hls.on(Hls.Events.ERROR, () => {
        this.setState({ loading: false }); // Stop loader on error
      });

    } else if (this.videoRef.current.canPlayType("application/vnd.apple.mpegurl")) {
      this.videoRef.current.src = src;
      this.setState({ loading: false });
    }
  };

  render() {
    const { showVideo, loading } = this.state;

    return (
      <div style={{ position: "relative", width: "100%" }}>
        {!showVideo && (
          <div
            style={{
              width: "100%",
              height: "200px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#ffffff"
            }}
          >
            <Spin tip="Loading video..." />
          </div>
        )}

        {showVideo && (
          <video
            ref={this.videoRef}
            controls
            autoPlay
            muted
            style={{ width: "100%", height: "auto" }}
          />
        )}
      </div>
    );
  }
}

export default HLSPlayer;
